module.exports = __webpack_public_path__ + "static/media/vui-react.347853bd.png";